<template>

  <default-view>
    <template slot="header">About</template>

    <template slot="toolbar-items"></template>

    <template slot="content" id="about-view">
      HAllo

      <tiptap-vuetify :extensions="extensions" style="text-align: left;">

      </tiptap-vuetify>

      <v-container>
        <v-row>
          <v-col cols="12">
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">

            <p>Soulful story about the difficult fate of the Probes.</p>

            <!-- Компонент counter потерялся, да и нужды в нем нет. -->
            <!--<counter></counter>-->

            <img src="../assets/logo_epiful.png" alt="logo" class="mb-5"/>

            <blockquote>
              &#8220;First, solve the problem. Then, reload the code.&#8221;
              <footer>
                <small>
                  <em>&mdash;Xun Xunson</em>
                </small>
              </footer>
            </blockquote>
          </v-col>
        </v-row>
      </v-container>

      <well-list></well-list>

    </template>

  </default-view>

</template>

<script>

	import DefaultView from './app/DefaultView'
	import {
		VContainer, VLayout, VRow, VCol, VFlex, VSlot,
	} from 'vuetify'

	import {
		TiptapVuetify,
		Bold
		// Heading, Bold, Italic, Strike, Underline, Code, Paragraph,
		// BulletList, OrderedList, ListItem, Link, Blockquote, HardBreak,
		// HorizontalRule, History
	} from 'tiptap-vuetify'

	import WellListComponent from "../components/plate/WellListComponent"

	export default {
		name: 'AboutView',
		components: {
			DefaultView,
			VContainer, VLayout, VRow, VCol, VFlex, VSlot,

			TiptapVuetify,
			Bold,
			// Heading, Bold, Italic, Strike, Underline, Code,
			// BulletList, OrderedList, ListItem, Link, History
			'well-list': WellListComponent
		},

		data: function () {
			return {
				extensions: [
					// Heading,
					Bold
					// Bold, Italic, Strike, Underline, Code,
					// BulletList, OrderedList, ListItem, Link, History
				],
			}
		}
	}

</script>
